import capitalize from './capitalize';

export default function unKebabCase(particle, capitalizeWords = true) {
    return (particle || '').split('-').map(word => (capitalizeWords ? capitalize(word) : word)).join(' ');
}
